export enum AlertBarType {
  JOB_ALERT = 'job-alerts',
  REQUEST_EDIT_ALERT = 'requestEditAlert',
  APP_ALERT = 'common-alert',
  CONTRACT_DRAWER = 'contract-drawer',
  JOB_PREFERENCES = 'job-preferences',
  CREDENTIAL_CENTER = 'credential-center',
}
